module.exports = __webpack_public_path__ + "static/media/nboost.5b1e1813.svg";